import type { Experiments, SiteAssetsExperimentMetadata } from '@wix/thunderbolt-symbols'
import { beckySpecs, siteAssetsModules } from '@wix/thunderbolt-commons'

export function stringifyExperiments(beckyExperiments: Experiments): string {
	return Object.keys(beckyExperiments)
		.map((key) => key.replace(/^specs.thunderbolt/, ''))
		.sort()
		.join(',')
}

export function filterBeckyExperiments(
	beckyExperiments: Experiments,
	module: string,
	specsMetadata: Record<string, SiteAssetsExperimentMetadata> = beckySpecs
) {
	return Object.entries(beckyExperiments).reduce<Experiments>((acc, [spec, value]) => {
		const metadata: SiteAssetsExperimentMetadata = specsMetadata[spec] || {}
		const modules: Array<string> = metadata.modules || siteAssetsModules
		if (modules.includes(module)) {
			acc[spec] = value
		}
		return acc
	}, {})
}
